import { isEmpty, isNil } from 'lodash-es';
import useUser from './useUser';

interface TimezoneStore {
  currentTimezone: string;
}

const useTimezone = (): TimezoneStore => {
  const { currentUser } = useUser();
  const { timeZone: browserTimezone } = Intl.DateTimeFormat().resolvedOptions();

  const currentTimezone = currentUser?.timezone
    ? currentUser.timezone
    : !isNil(browserTimezone) && !isEmpty(browserTimezone)
      ? browserTimezone
      : 'UTC';

  return {
    currentTimezone,
  };
};

export default useTimezone;
